import { useCallback, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_STAFF_MANAGEMENT_CHECK_IN_HISTORY } from "graphql/query/staff-management-gql";
import { buildStaffCheckInHistoryVariables } from "../helpers/staff-check-in-history-api-helper";


const EMPTY_MODEL = { data: [], paginatorInfo: { total: 0 } };

const useStaffCheckInHistory = ({ eeID, period, page }) => {
    const variables = useMemo(() => buildStaffCheckInHistoryVariables({
        eeID,
        period,
        page,
    }), [ eeID, period, page ]);
    const { data, loading, error, refetch } = useQuery(GET_STAFF_MANAGEMENT_CHECK_IN_HISTORY, {
        skip: !variables.where,
        variables,
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true,
    });
    const retry = useCallback(() => {
        if (variables.where)
        {
            // Apollo exposes the retry error through query state; avoid an unhandled click promise.
            return refetch().catch(() => undefined);
        }
    }, [ refetch, variables.where ]);

    return {
        tableModel: variables.where ? data?.exhibitionEventCheckinLogs ?? EMPTY_MODEL : EMPTY_MODEL,
        loading,
        error,
        retry,
        variables,
    };
};

export default useStaffCheckInHistory;
